<header>
    <nav #navbar class='main-panel navbar navbar-expand-lg navbar-toggleable-sm navbar-dark'>
        <div class="container-fluid">
            <!-- <a class="navbar-brand" [routerLink]='["/"]'></a> -->
            <!-- <span>{{IsMelConnect}}</span> -->
            <img *ngIf="!IsMeL" [src]="EABIconPath" [height]="isMenuTogglerDisplayed() ? 50 : 60" (click)="goToHome()" class="clickable">
            <img *ngIf="IsMeL" [src]="MELIconPath" [height]="isMenuTogglerDisplayed() ? 50 : 60" (click)="goToHome()" class="clickable">
           
           
            <!-- <div *ngIf="!CoreData.IsMobile" class="mx-3" style="height: 50px; width: 2px; background: white;"></div> -->
            <!-- <span *ngIf="!CoreData.IsMobile" style="color: white; font-size: 32px;"> {{AppName}}</span> -->
        
            <button #toggleButton class="navbar-toggler" type="button" data-toggle="collapse"
                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- MOBILE UI -->
            
            <!-- [ngClass]='{"showminimenu": !IsLoggedIn() || isMenuTogglerDisplayed()}' -->
            <div *ngIf="!isMenuTogglerDisplayed() && IsLoggedIn()" class="d-flex justify-content-center align-self-start align-content-start" style="width:120px;" >
                <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon class="material-symbols-outlined" style="color: white;">more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <div mat-menu-item class="text-center unclickable" (click)="$event.stopPropagation()">
                        Version: {{AppVersion}}
                    </div>
                    <div mat-menu-item class="text-center unclickable" (click)="$event.stopPropagation()">
                        <div>{{CoreData.User?.FirstName}} {{CoreData.User?.LastName}}</div>
                    </div>
                    <button mat-menu-item (click)="getSpecificFiles(1)">
                        <mat-icon class="material-symbols-outlined">description</mat-icon>
                        <span>CGU</span>
                    </button>
                    <button mat-menu-item (click)="getSpecificFiles(2)">
                        <mat-icon class="material-symbols-outlined">description</mat-icon>
                        <span>Confidentialité</span>
                    </button>
                </mat-menu>
            </div>
            <div *ngIf="!IsLoggedIn()" class="collapse navbar-collapse" style="height: 61px;">
                <!-- This a dummy container to align the header -->
            </div>
        </div>
    </nav>

</header>